import CommomProxy from '@/components/proxy/CommomProxy'
import clinicDoctor from '@/views/clinic/clinicDoctor'
import doctorDetail from '@/views/clinic/doctorDetail'
import doctorList from '@/views/clinic/doctorList'

let child_routes = [{
        path: '/',
        name: 'clinicNav',
        component: resolve => {
            require(['@/views/clinic/clinicNav.vue'], resolve);
        },
        meta: {
            title: '互联网医院'
        }
    },
    {
        // path: 'hospitalIntroduction/:id',
        path: 'hospitalIntroduction',
        name: 'hospitalIntroduction',
        component: resolve => {
            require(['@/views/clinic/hospitalIntroduction.vue'], resolve);
        },
        meta: {
            title: '医院介绍'
        }
    },
    {
        path: 'clinicList',
        name: 'clinicList',
        component: resolve => {
            require(['@/views/clinic/hisClinicList.vue'], resolve);
        },
        meta: {
            title: '附近医院'
        }
    },
    {
        path: 'hisClinicList',
        name: 'hisClinicList',
        component: resolve => {
            require(['@/views/clinic/clinicList.vue'], resolve);
        },
        meta: {
            title: '附近医院'
        }
    },
    {
        path: 'clinicListDetail/:id',
        name: 'clinicListDetail',
        component: resolve => {
            require(['@/views/clinic/clinicListDetail.vue'], resolve);
        },
        meta: {
            title: '附近医院详情'
        }
    },
    {
        path: 'clinicDoctorOrKeshi',
        name: 'clinicDoctorOrKeshi',
        component: resolve => {
            require(['@/views/clinic/clinicDoctorOrKeshi.vue'], resolve);
        },
        meta: {
            title: '查看医生或科室'
        }
    },
    {
        path: 'clinicDoctor',
        name: 'clinicDoctor',
        meta: {
            title: '附近医院'
        },
        component: clinicDoctor
    },
    {
        path: 'doctorList',
        name: 'doctorList',
        component: doctorList,
        meta: {
            title: '找医生'
        }
    },
    {
        path: 'doctorDetail/:id',
        name: 'doctorDetail',
        meta: {
            title: '医生工作室'
        },
        component: doctorDetail
    },
    {
        path: 'hospitalDetail',
        name: 'hospitalDetail',
        component: resolve => {
            require(['@/views/clinic/hospitalDetail.vue'], resolve);
        },
        meta: {
            title: '查看医院详情'
        }
    },
    {
        path: 'clinicSearch/:from',
        name: 'clinicSearch',
        component: resolve => {
            require(['@/views/clinic/clinicSearch.vue'], resolve);
        },
        meta: {
            title: '医院或医生搜索',
            normal: true
        }
    },
    {
        path: 'mine',
        name: 'mine',
        component: resolve => {
            require(['@/views/clinic/mine.vue'], resolve);
        },
        meta: {
            title: '我的'
        }
    },
    {
        path: 'famousDoctorList',
        name: 'famousDoctorList',
        component: resolve => {
            require(['@/views/clinic/famousDoctorList.vue'], resolve);
        },
        meta: {
            title: '名医风采'
        }
    },
    {
        path: 'nurseList',
        name: 'nurseList',
        component: resolve => {
            require(['@/views/clinic/nurseList.vue'], resolve);
        },
        meta: {
            title: '找护士'
        }
    },
    {
        path: 'nurseDetail/:id',
        name: 'nurseDetail',
        component: resolve => {
            require(['@/views/clinic/nurseDetail.vue'], resolve);
        },
        meta: {
            title: '护士工作室'
        },
    },
    {
        path: 'phoneDoctorList',
        name: 'phoneDoctorList',
        component: resolve => {
            require(['@/views/clinic/phoneDoctorList.vue'], resolve);
        },
        meta: {
            title: '找医生'
        },
    },
]

let route = [{
    path: '/clinic',
    component: CommomProxy,
    children: child_routes
}]

export default route


// WEBPACK FOOTER //
// ./src/router/clinic.js